import { useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'

export function useIsDepositGuaranteeEnabled() {
  return useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.depositGuaranteeEnabled === true
  )
}
